import {app} from "@/modules/app";
import {useStackRouteComponent} from "@/packages/stack-router/hooks/useStackRoute";

app.addRoutes([
    {
        parent: 'page',
        path: '/reviews',
        component: () => import("@/pages/review/list.vue"),
        meta: {
            title: 'Отзывы'
        }
    },
    {
        parent: 'page',
        path: '/review/make',
        component: useStackRouteComponent( () => import("@/pages/review/make.dialog.vue")),
    }
])

